import { Paper, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";

export default function SocialMediaWidget() {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Paper elevation={0} sx={{ borderRadius: "24px", p: 3, height: "100%", backgroundColor: colors.primary[900], minHeight: 400 }}>
      <Typography variant="overline" fontWeight={600} color={colors.primary[700]} sx={{ display: "block", mb: 2 }}>
        SOCIAL MEDIA TO DO
      </Typography>
    </Paper>
  );
}